import BreadcrumbChevronIcon from "@/assets/images/icons/breadcrumb-chevron.svg";
import BreadcrumbHomeIcon from "@/assets/images/icons/breadcrumb-home.svg";
import { useRouter } from "expo-router";
import { useState } from "react";
import { Platform, Pressable } from "react-native";
import { XStack } from "tamagui";
import { SubtitleText } from "@/components/ui/Typography";

interface BreadcrumbHeaderProps {
  courseTitle?: string;
  courseSlug?: string;
  seasonTitle?: string;
  lessonTitle?: string;
  collectionId?: string | number;
  collectionTitle?: string;
  collectionSlug?: string;
  referrer?: string;
  insetX?: string | number;
}

export function BreadcrumbHeader({
  courseTitle,
  courseSlug,
  seasonTitle,
  lessonTitle,
  collectionTitle,
  collectionSlug,
  referrer,
  insetX = "$4",
}: BreadcrumbHeaderProps) {
  const router = useRouter();
  const [hover, setHover] = useState(false);

  if (Platform.OS !== "web") return null;
  if (!courseTitle && !collectionTitle) return null;

  const handleBack = () => {
    if (collectionTitle && referrer) {
      return router.replace(referrer as any);
    }

    if (courseSlug) {
      return router.replace({
        pathname: "/courses/[course-slug]",
        params: { "course-slug": String(courseSlug) },
      });
    }

    return router.replace("/courses");
  };

  const goToCourse = () => {
    if (courseSlug) {
      return router.replace({
        pathname: "/courses/[course-slug]",
        params: { "course-slug": String(courseSlug) },
      });
    }
    return router.replace("/courses");
  };

  const goToCollection = () => {
    if (referrer) {
      return router.replace(referrer as any);
    }
    return router.replace("/courses");
  };

  return (
    <XStack
      ai="center"
      jc="flex-start"
      flex={1}
      minWidth={0}
      px={insetX}
      py={8}
      $gtSm={{ py: 12 }}
    >
      <XStack ai="center" gap={0} flexShrink={1} minWidth={0}>
        {courseTitle && !collectionTitle ? (
          <>
            <Pressable
              onPress={handleBack}
              onHoverIn={() => setHover(true)}
              onHoverOut={() => setHover(false)}
              style={{ cursor: "pointer", marginRight: 8 }}
              accessibilityRole="button"
              accessibilityLabel="Go back"
              hitSlop={8}
            >
              <BreadcrumbHomeIcon width={17} height={19} />
            </Pressable>

            <XStack marginRight={16}>
              <BreadcrumbChevronIcon width={6} height={10} />
            </XStack>

            <Pressable
              onPress={goToCourse}
              style={{
                cursor: "pointer",
                flexShrink: 1,
                minWidth: 0,
                marginRight: (lessonTitle || seasonTitle) ? 8 : 0,
              }}
              onHoverIn={() => setHover(true)}
              onHoverOut={() => setHover(false)}
            >
              <SubtitleText
                fontWeight="500"
                color={hover ? "#795C40" : "#2B2B2B"}
                numberOfLines={1}
              >
                {courseTitle}
              </SubtitleText>
            </Pressable>

            {lessonTitle ? (
              <>
                <XStack marginRight={16}>
                  <BreadcrumbChevronIcon width={6} height={10} />
                </XStack>
                <SubtitleText
                  fontWeight="500"
                  color="#2B2B2B"
                  numberOfLines={1}
                  flexShrink={1}
                >
                  {lessonTitle}
                </SubtitleText>
              </>
            ) : seasonTitle ? (
              <>
                <XStack marginRight={16}>
                  <BreadcrumbChevronIcon width={6} height={10} />
                </XStack>
                <SubtitleText
                  fontWeight="500"
                  color="#2B2B2B"
                  numberOfLines={1}
                  flexShrink={1}
                >
                  {seasonTitle}
                </SubtitleText>
              </>
            ) : null}

          </>
        ) : null}

        {collectionTitle ? (
          <>
            <Pressable
              onPress={handleBack}
              onHoverIn={() => setHover(true)}
              onHoverOut={() => setHover(false)}
              style={{ cursor: "pointer", marginRight: 8 }}
              accessibilityRole="button"
              accessibilityLabel="Go back"
              hitSlop={8}
            >
              <BreadcrumbHomeIcon width={17} height={19} />
            </Pressable>

            <XStack marginRight={16}>
              <BreadcrumbChevronIcon width={6} height={10} />
            </XStack>
            <Pressable
              onPress={goToCollection}
              style={{ cursor: "pointer", flex: 1, minWidth: 0 }}
              onHoverIn={() => setHover(true)}
              onHoverOut={() => setHover(false)}
            >
              <SubtitleText
                fontWeight="500"
                color={hover ? "#795C40" : "#2B2B2B"}
                numberOfLines={1}
              >
                {collectionTitle}
              </SubtitleText>
            </Pressable>
          </>
        ) : null}
      </XStack>
    </XStack>
  );
}
